import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import { Container, Row, Col } from 'reactstrap';
import Immutable from 'immutable';
import CostSummary from './CostSummary';
import PaymentForm from './PaymentForm';
import Loader from '../../../common/Loader';
import { clearBookingState } from '../../../../actions';
import { SEARCH_STEP_PATH } from '../../../../config/paths';
import { CIVA_BOOKING_PAYMENT_STEP_INDEX } from '../../../../config/constants';

// todo: remove when class is complete
class Payment extends Component {
  static propTypes = {
    trip: PropTypes.shape({
      source: PropTypes.string.isRequired,
      destination: PropTypes.string.isRequired,
      departureTime: PropTypes.number.isRequired,
    }).isRequired,
    passengers: PropTypes.arrayOf(
      PropTypes.shape({
        fullName: PropTypes.string.isRequired,
        idDocumentNumber: PropTypes.string.isRequired,
        salePrice: PropTypes.number.isRequired,
      }),
    ).isRequired,
    totalPrice: PropTypes.number.isRequired,
    creditNote: PropTypes.instanceOf(Immutable.Map).isRequired,
    seatsNumber: PropTypes.number.isRequired,
    postingPayment: PropTypes.bool.isRequired,
    requiresTwoStepAuthorization: PropTypes.bool.isRequired,
    dispatchClearBookingState: PropTypes.func.isRequired,
    dispatchReplace: PropTypes.func.isRequired,
    activeSalesSession: PropTypes.instanceOf(Immutable.Map).isRequired,
    discountCodeId: PropTypes.number,
  };

  static defaultProps = {
    discountCodeId: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      contingencyData: [],
    };

    const { dispatchReplace, seatsNumber, dispatchClearBookingState } = props;

    if (seatsNumber === 0) {
      dispatchReplace(SEARCH_STEP_PATH);
    }

    dispatchClearBookingState(CIVA_BOOKING_PAYMENT_STEP_INDEX);
  }

  handleContingencyChange = (contingencyData) => {
    this.setState({ contingencyData });
  };

  render() {
    const {
      trip,
      passengers,
      totalPrice,
      creditNote,
      postingPayment,
      activeSalesSession,
      requiresTwoStepAuthorization,
    } = this.props;
    const { contingencyData } = this.state;

    const isContingencySalesSession =
      activeSalesSession.get('workstation').contingency;

    if (!trip) {
      return null;
    }

    const agency = activeSalesSession.get('agency');

    const discountPercentage =
      agency && agency.discountPercentage
        ? Number(agency.discountPercentage)
        : 0;

    const isCorporateAgency =
      agency && agency.corporate === true && discountPercentage > 0;

    return (
      <Container>
        {postingPayment && !requiresTwoStepAuthorization && <Loader />}
        <Row>
          <Col>
            <CostSummary
              costs={passengers}
              total={totalPrice}
              creditNote={creditNote}
              showExtraColumns={isContingencySalesSession}
              onContingencyChange={this.handleContingencyChange}
              isCorporateAgency={isCorporateAgency}
              discountPercentage={discountPercentage}
            />
          </Col>
        </Row>
        <PaymentForm
          totalPrice={totalPrice}
          creditNote={this.props.creditNote}
          seatsNumber={this.props.seatsNumber}
          contingencyData={contingencyData}
          discountCodeId={this.props.discountCodeId}
          submitting={postingPayment}
          disabledButton={postingPayment && !requiresTwoStepAuthorization}
        />
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  const passengersTickets = state.BookingUnit.Booking.getIn([
    'payment',
    'customerOrder',
    'passengers',
  ]);

  let totalPrice = 0;

  if (passengersTickets)
    passengersTickets.forEach((passengerTicket) => {
      totalPrice += passengerTicket.salePrice;
    });

  return {
    postingPayment: state.BookingUnit.Booking.getIn([
      'payment',
      'postingPayment',
    ]),
    trip: state.BookingUnit.Booking.getIn(['payment', 'customerOrder', 'trip']),
    passengers: state.BookingUnit.Booking.getIn([
      'payment',
      'customerOrder',
      'passengers',
    ]),
    totalPrice,
    creditNote: state.BookingUnit.Booking.getIn(['payment', 'creditNote']),
    seatsNumber: state.BookingUnit.Booking.getIn([
      'seats',
      'seatReservations',
    ]).count(),
    activeSalesSession: state.SalesUnit.SalesSession.getIn([
      'active',
      'content',
    ]),
    discountCodeId: state.BookingUnit.Booking.getIn([
      'payment',
      'customerOrder',
      'discountCodeId',
    ]),
    requiresTwoStepAuthorization: state.TwoStepAuthorization.get(
      'requiresTwoStepAuthentication',
    ),
  };
};

const mapDispatchToProps = {
  dispatchReplace: replace,
  dispatchClearBookingState: clearBookingState,
};

export default connect(mapStateToProps, mapDispatchToProps)(Payment);
